import type {
  GetAiAuditByIdQuery,
  GetAiAuditByIdQueryVariables,
  GetAiAuditsQuery,
  GetAiAuditsQueryVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const GET_AI_AUDITS: TypedDocumentNode<
  GetAiAuditsQuery,
  GetAiAuditsQueryVariables
> = gql`
  query GetAiAudits($limit: Int) {
    aiAudits(limit: $limit) {
      id
      createdAt
    }
  }
`;

export const GET_AI_AUDIT_BY_ID: TypedDocumentNode<
  GetAiAuditByIdQuery,
  GetAiAuditByIdQueryVariables
> = gql`
  query GetAiAuditById($id: String!) {
    aiAudit(id: $id) {
      id
      createdAt
      input
      output
    }
  }
`;
